import React, { useState } from "react";
import { loadRazorpayScript } from "./loadRazorpay";
import { auth } from "../utils/firebase";
import toasted from "../config/toasted";
import { GeneratingTokens } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { currency } from "../config/config";


const API_BASE = "https://asia-south1-heyprompt-2d910.cloudfunctions.net";


const plans = [
     {
          id: "starter_249",
          title: "150 credits",
          price: `₹249`,
          credits: 150,
          desc: "Starter pack for HeyPrompt",
          features: [
               "₹1.66 per credit",
          ],
          featured: true
     },
     {
          id: "pro_499",
          title: "400 credits",
          price: `₹499`,
          credits: 400,
          desc: "Best value pack",
          features: [
               "₹1.24 per credit",
          ],
          featured: false
     },
     {
          id: "ultra_1000",
          title: "1000 credits",
          price: `₹1,000`,
          credits: 1000,
          desc: "Power user pack",
          features: [
               "₹0.99 per credit",
          ],
          featured: false
     }
];

const RazorpayPlans = ({ userData }) => {

     console.log(userData)


     const currentUser = auth.currentUser;
     const [loadingPlan, setLoadingPlan] = useState("");
     const [open, setOpen] = useState(false);
     const [selectedPlan, setSelectedPlan] = useState(null);

     const onCloseModal = () => {
          setOpen(false);
          setSelectedPlan(null);
     };

     const handleBuy = async (planId) => {


          try {
               setLoadingPlan(planId);

               const loaded = await loadRazorpayScript();
               if (!loaded) {
                    alert("Razorpay SDK load failed");
                    return;
               }

               if (!currentUser) {
                    alert("Please login first");
                    return;
               }

               const token = await currentUser.getIdToken();

               const orderRes = await fetch(`${API_BASE}/createRazorpayOrder`, {
                    method: "POST",
                    headers: {
                         "Content-Type": "application/json",
                         Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ planId }),
               });

               const rawText = await orderRes.text();
               console.log("RAW RESPONSE:", rawText);

               let orderData = null;

               try {
                    orderData = JSON.parse(rawText);
               } catch (err) {
                    alert(`Server returned non-JSON response: ${rawText}`);
                    return;
               }

               if (!orderRes.ok || !orderData?.success) {
                    alert(orderData?.message || "Order creation failed");
                    return;
               }


               const options = {
                    key: orderData.key,
                    amount: orderData.order.amount,
                    currency: orderData.order.currency,
                    name: "HeyPrompt",
                    image: "https://heyprompt.online/apple-touch-icon.png",
                    description: orderData.plan.title,
                    order_id: orderData.order.id,
                    handler: async function (response) {
                         const verifyRes = await fetch(`${API_BASE}/verifyRazorpayPayment`, {
                              method: "POST",
                              headers: {
                                   "Content-Type": "application/json",
                                   Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify({
                                   razorpay_payment_id: response.razorpay_payment_id,
                                   razorpay_order_id: response.razorpay_order_id,
                                   razorpay_signature: response.razorpay_signature,
                              }),
                         });

                         const verifyData = await verifyRes.json();

                         if (verifyData.success) {
                              toasted.success(`Payment successful. Credits added.`);
                              setOpen(true);
                              setSelectedPlan(options)
                         } else {
                              alert(verifyData.message || "Payment verification failed");
                         }
                    },
                    prefill: {
                         name: userData?.name || userData?.displayName || "",
                         email: userData?.email || "",
                    },
                    readonly: {
                         name: true,
                         email: true,
                    },

                    hidden: {
                         contact: true,
                         email: true,

                    },
                    notes: {
                         uid: userData?.uid || "",
                         email: userData?.email || "",
                         userName: userData?.name || userData?.displayName || "",
                         planId: orderData?.plan?.id || "",
                         planTitle: orderData?.plan?.title || "",
                         amount: String(orderData?.plan?.amount || ""),
                    },
                    theme: {
                         color: "#fff",
                         backdrop_color: "#fff",
                    },
                    modal: {
                         backdropclose: false,
                         escape: true,
                         animation: true,
                    },
               };

               const paymentObject = new window.Razorpay(options);
               paymentObject.open();
          } catch (error) {
               console.error(error);
               alert(error.message || "Something went wrong");
          } finally {
               setLoadingPlan("");
          }
     };



     return (
          <>
               <div className="plans-grid plans-grid-scroll">
                    {plans.map((plan, index) => (
                         <div key={index} className={`pricing-card text-center ${plan.featured ? "is-featured" : ""}`}>
                              {plan.badge && <div className="popular-badge">{plan.badge}</div>}

                              <div className="card-top">
                                   <span className="plan-tag">
                                        <GeneratingTokens />
                                   </span>
                                   <h3 className="plan-title">{plan.title}</h3>
                                   <p className="plan-desc">{plan.desc}</p>
                              </div>

                              <div className="plan-price mb-2">
                                   <span className="currency">{plan.price}</span>
                                   <span className="period">{plan.duration}</span>
                              </div>

                              <ul className="feature-list">
                                   {plan.features.map((feature, i) => (
                                        <li key={i} className='justify-content-center'>
                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                             <span dangerouslySetInnerHTML={{ __html: feature }} />
                                        </li>
                                   ))}
                              </ul>

                              {userData?.subscriptions === 'paid' ? (
                                   <button
                                        className="cta-button"
                                        onClick={() => handleBuy(plan?.id)}
                                        disabled={loadingPlan === plan.id}
                                   >
                                        {loadingPlan === plan.id ? "Processing..." : `Buy ${plan?.credits} Credits`}
                                   </button>
                              ) : (
                                   <p className="upgrade-prompt">
                                        To purchase credits, please
                                        <Link to="/pricing?subscription" className="upgrade-link"> upgrade your account</Link>
                                        {" "}to a premium subscription.
                                   </p>
                              )}


                              {currentUser ? "" : <Link to="/login" className="login-link">Log in to subscribe</Link>}
                         </div>
                    ))
                    }
               </div>






               <Modal open={open} onClose={onCloseModal} center classNames={{ modal: 'customModal' }}>

                    <div className="checkout-container">
                         <h2>🎉 Congratulations!</h2>
                         <p className="plan-info">Plan: <b>{selectedPlan?.description}</b> | Amount: <b>{selectedPlan?.amount / 100} {currency}</b></p>
                         <p className="payment-apps-note">
                              Your payment request has been received successfully.
                         </p>
                         <div className="payment-form mt-3">
                              <Link className="submit-btn" to="/submit" >
                                   submit Your Art
                              </Link>
                         </div>
                    </div>

               </Modal>
          </>
     );
};

export default RazorpayPlans;